
import { nextTick, reactive } from 'vue';
import { Options, Vue } from 'vue-class-component';
import { Prop, Ref, Watch } from 'vue-property-decorator';
import NButton from '@/uikit/buttons/NButton.vue';

@Options({
  name: 'AnnexAlarmStatusHelper',
  components: { NButton }
})
export default class AnnexAlarmStatusHelper extends Vue {}
